<template>
  <!-- Pricing-Two  Plan -->
  <section class="pricing-plan pricing-plan-seven">
    <div class="container">
      <div class="section-heading-two section-heading-seven text-center">
        <div class="row">
          <div class="col-md-12 aos aos-init aos-animate" data-aos="fade-up">
            <img
              src="@/assets/img/heading-logo-small.png"
              class="img-fluid"
              alt="title-img"
            />
            <h2>Our Pricing Plan</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
          </div>
        </div>
      </div>
      <div class="price-wrap">
        <div class="row">
          <div class="col-lg-3 col-md-6 d-flex aos" data-aos="fade-up">
            <div class="price-card price-seven flex-fill">
              <div>
                <div class="price-head">
                  <h4>$10 <span>/ month</span></h4>
                  <div class="price-level">
                    <h6>Intro</h6>
                  </div>
                </div>
                <div class="price-body">
                  <p>For most businesses that want to otpimize web queries</p>
                  <ul>
                    <li class="active">Chat support</li>
                    <li class="active">All limited links</li>
                    <li class="active">Own analytics platform</li>
                    <li class="active">Optimize hashtags</li>
                    <li class="active">Unlimited users</li>
                  </ul>
                </div>
              </div>
              <div class="choose-btn">
                <router-link to="login" class="btn viewdetails-btn"
                  >Choose Plan
                  <i class="fa-solid fa-arrow-right"> </i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 d-flex aos" data-aos="fade-up">
            <div class="price-card price-seven flex-fill">
              <div>
                <div class="price-head">
                  <h4>$50 <span>/ month</span></h4>
                  <div class="price-level">
                    <h6>Base</h6>
                  </div>
                </div>
                <div class="price-body">
                  <p>For most businesses that want to otpimize web queries</p>
                  <ul>
                    <li class="active">Chat support</li>
                    <li class="active">All limited links</li>
                    <li class="active">Own analytics platform</li>
                    <li class="active">Optimize hashtags</li>
                    <li class="active">Unlimited users</li>
                  </ul>
                </div>
              </div>
              <div class="choose-btn">
                <router-link to="login" class="btn viewdetails-btn"
                  >Choose Plan
                  <i class="fa-solid fa-arrow-right"> </i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 aos" data-aos="fade-up">
            <div class="price-card price-seven active flex-fill">
              <div>
                <div class="price-head">
                  <div class="text-end pop">
                    <span class="feature">MOST POPULAR</span>
                  </div>
                  <h4>$100 <span>/ month</span></h4>
                  <div class="price-level">
                    <h6>Pro</h6>
                  </div>
                </div>
                <div class="price-body">
                  <p>For most businesses that want to otpimize web queries</p>
                  <ul>
                    <li class="active">Chat support</li>
                    <li class="active">All limited links</li>
                    <li class="active">Own analytics platform</li>
                    <li class="active">Optimize hashtags</li>
                    <li class="active">Unlimited users</li>
                  </ul>
                </div>
              </div>
              <div class="choose-btn">
                <router-link to="login" class="btn viewdetails-btn"
                  >Choose Plan
                  <i class="fa-solid fa-arrow-right"> </i>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 d-flex aos" data-aos="fade-up">
            <div class="price-card price-seven flex-fill">
              <div>
                <div class="price-head">
                  <h4>$200 <span>/ month</span></h4>
                  <div class="price-level">
                    <h6>Enterprise</h6>
                  </div>
                </div>
                <div class="price-body">
                  <p>For most businesses that want to otpimize web queries</p>
                  <ul>
                    <li class="active">Chat support</li>
                    <li class="active">All limited links</li>
                    <li class="active">Own analytics platform</li>
                    <li class="active">Optimize hashtags</li>
                    <li class="active">Unlimited users</li>
                  </ul>
                </div>
              </div>
              <div class="choose-btn">
                <router-link to="login" class="btn viewdetails-btn"
                  >Choose Plan
                  <i class="fa-solid fa-arrow-right"> </i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Pricing-Two  Plan -->

  <!-- testimonial-section-seven Section -->
  <section class="testimonial-section-seven">
    <div class="container">
      <div class="section-heading-two section-heading-seven text-center">
        <div class="row">
          <div class="col-md-12 aos aos-init aos-animate" data-aos="fade-up">
            <img
              src="@/assets/img/heading-logo-small.png"
              class="img-fluid"
              alt="title-img"
            />
            <h2>People Talking About Us</h2>
            <p>Our biggest clients</p>
          </div>
        </div>
      </div>
      <div class="testi-carousel">
        <div class="test-slider owl-carousel owl-theme">
          <Carousel
            :wrap-around="true"
            :settings="settings"
            :breakpoints="breakpoints"
          >
            <Slide v-for="item in IndexSevenTestimonial" :key="item.id">
              <div class="testi-widget-seven aos" data-aos="fade-up">
                <div class="test-details">
                  <div class="icon-blk">
                    <img
                      :src="require(`@/assets/img/profiles/${item.image}`)"
                      alt="Dreamstrip Testimonials"
                    />
                  </div>
                  <div class="people-name">
                    <h5>{{ item.title }}</h5>
                    <div class="review">
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <div class="testi-content">
                  <h5>{{ item.text }}</h5>
                  <p>{{ item.details }}</p>
                </div>
                <div class="testi-location">
                  <h6>{{ item.name }}</h6>
                  <p><i class="feather-map-pin"></i> {{ item.place }}</p>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </section>
  <!-- /testimonial-section-seven Section -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexSevenTestimonial from "@/assets/json/indexSevenTestimonial.json";
export default {
  data() {
    return {
      IndexSevenTestimonial: IndexSevenTestimonial,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991 and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
